import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import SaasPage from "../pages/saas/page";
import Home from "../pages/home/page";
import ResidentPage from "../pages/profile/resident/page";
import CommercialPage from "../pages/profile/commercial/page";
import CommercialDetailPage from "../pages/profile/commercial/detail/page";
import UserDetailPage from "../pages/profile/detail/page";
import ResidentScenePage from "../pages/profile/resident/scene/page";
import RealtimeMeterPage from "../pages/meter/realtime/page";
import MeterDevicePage from "../pages/meter/device/page";
import SalesPurchasePage from "../pages/sales/purchase/page";
import SalesRecordsPage from "../pages/sales/records/page";
import LadderPricePage from "../pages/price/ladder/page";
import PriceDispatchPage from "../pages/price/dispatch/page";
import DailyReportPage from "../pages/report/daily/page";
import AIReportPage from "../pages/report/ai/page";
import CustomReportPage from "../pages/report/custom/page";
import PaymentPage from "../pages/payment/page";
import SettingsPage from "../pages/settings/page";
import AlarmPage from "../pages/alarm/page";
import GisPage from "../pages/gis/page";
import SafetyPage from "../pages/safety/page";
import InstallPage from "../pages/install/page";
import BankPage from "../pages/bank/page";
import MaterialPage from "../pages/material/page";
import SmsPage from "../pages/sms/page";
import FeePage from "../pages/fee/page";
import MobilePage from "../pages/mobile/page";
import ScreenPage from "../pages/screen/page";
import InspectorPage from "../pages/safety/inspector/page";
import ServicePage from "../pages/service/page";
import PrivateRoute from "../components/feature/PrivateRoute";

const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  { path: "/mobile", element: <MobilePage /> },
  {
    path: "/saas",
    element: (
      <PrivateRoute>
        <SaasPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Home />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile/resident",
    element: (
      <PrivateRoute>
        <ResidentPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile/commercial",
    element: (
      <PrivateRoute>
        <CommercialPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile/commercial/:id",
    element: (
      <PrivateRoute>
        <CommercialDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile/:id",
    element: (
      <PrivateRoute>
        <UserDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile/:id/scene",
    element: (
      <PrivateRoute>
        <ResidentScenePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/meter/realtime",
    element: (
      <PrivateRoute>
        <RealtimeMeterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/meter/history",
    element: (
      <PrivateRoute>
        <RealtimeMeterPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/meter/device",
    element: (
      <PrivateRoute>
        <MeterDevicePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/sales/purchase",
    element: (
      <PrivateRoute>
        <SalesPurchasePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/sales/records",
    element: (
      <PrivateRoute>
        <SalesRecordsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/fee/query",
    element: (
      <PrivateRoute>
        <FeePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/fee/arrears",
    element: (
      <PrivateRoute>
        <FeePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/price/ladder",
    element: (
      <PrivateRoute>
        <LadderPricePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/price/history",
    element: (
      <PrivateRoute>
        <LadderPricePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/price/dispatch",
    element: (
      <PrivateRoute>
        <PriceDispatchPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/bank",
    element: (
      <PrivateRoute>
        <BankPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/safety",
    element: (
      <PrivateRoute>
        <SafetyPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/safety/inspector",
    element: (
      <PrivateRoute>
        <InspectorPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/install",
    element: (
      <PrivateRoute>
        <InstallPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/report",
    element: (
      <PrivateRoute>
        <DailyReportPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/report/daily",
    element: (
      <PrivateRoute>
        <DailyReportPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/report/monthly",
    element: (
      <PrivateRoute>
        <DailyReportPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/report/ai",
    element: (
      <PrivateRoute>
        <AIReportPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/report/custom",
    element: (
      <PrivateRoute>
        <CustomReportPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/alarm",
    element: (
      <PrivateRoute>
        <AlarmPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/gis",
    element: (
      <PrivateRoute>
        <GisPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/screen",
    element: (
      <PrivateRoute>
        <ScreenPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/sms",
    element: (
      <PrivateRoute>
        <SmsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/material",
    element: (
      <PrivateRoute>
        <MaterialPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/payment",
    element: (
      <PrivateRoute>
        <PaymentPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/service",
    element: (
      <PrivateRoute>
        <ServicePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <PrivateRoute>
        <SettingsPage />
      </PrivateRoute>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
